import CommonConstants from "@/utils/constants/CommonConstants.ts";
import ListPlace from "@/utils/presenters/ListPlace.ts";

export default class StorageUtils {
  static calcListViewGridPath(place: ListPlace): string {
    return "list" + CommonConstants.SEPARATOR + place.src + CommonConstants.SEPARATOR +
      place.listViewName + CommonConstants.SEPARATOR + place.entityType;
  }

  static calcDashboardTableStatePath(chartLine: namaTypes.DTOUserDashbordChartLine) {
    return chartLine.chartType! + "_id_" + chartLine.widgetId + "_row_" + chartLine.rowNumber + "_col_" + chartLine.colNumber;
  }
}
